import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {
  BfAccordion,
  BfBadge,
  BfIcon,
  BfFlex,
  Colors,
  IconType,
  Sizes,
} from '@finetic/bikefitting-ui'


export default /*@__PURE__*/_defineComponent({
  __name: 'CommonFilterAccordion',
  props: {
    icon: {},
    title: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(BfAccordion), null, {
    "header-left": _withCtx(() => [
      _createVNode(_unref(BfFlex), {
        align: "center",
        gap: "1.6rem"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(BfIcon), {
            icon: __props.icon,
            size: _unref(Sizes).xxl,
            type: _unref(IconType).Contained,
            "contained-padding": _unref(Sizes).xxs
          }, null, 8, ["icon", "size", "type", "contained-padding"]),
          _createElementVNode("h3", null, _toDisplayString(__props.title), 1)
        ]),
        _: 1
      })
    ]),
    "header-right": _withCtx(() => [
      _createVNode(_unref(BfBadge), {
        color: _unref(Colors).Success
      }, null, 8, ["color"])
    ]),
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }))
}
}

})